import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ChevronRight, MapPin, Phone, Mail } from 'react-feather';
import config from '../config';
import { getPageTree } from '../utils/contentful';
import styles from './Footer.module.scss';

export default class Footer extends Component {
  static propTypes = {
    pages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  };

  state = {
    pages: [],
  };

  componentWillMount() {
    const indexPage = getPageTree(this.props.pages);
    this.setState({ pages: [indexPage, ...indexPage.subpages ] });
  }

  render() {
    const {
      siteName,
      contacts: { email, phoneNo, address },
    } = config;

    return (
      <footer className={styles.root}>

        <div className={styles.sections}>
          <div className={styles.sectionsContainer}>

            <div className={styles.section}>
              <h4 className={styles.sectionTitle}>{siteName}</h4>
              <p className={styles.description}>We provide drilling, completion and fracture stimulation engineering, as well as field supervision services for our client operators. Our primary expertise is in horizontal drilling and completion operations in the Williston Basin.</p>
            </div>

            <div className={styles.section}>
              <h4 className={styles.sectionTitle}>Quick Links</h4>
              <ul className={styles.quickLinks}>
                {this.state.pages.map(({ title, slug, path }) => (
                  <li key={path}>
                    <a className={styles.quickLink} href={path}>
                      <ChevronRight /> {title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.section}>
              <h4 className={styles.sectionTitle}>Contact Details</h4>
              <ul className={styles.contacts}>
                <li className={styles.contact}>
                  <MapPin className={styles.contactIcon} />
                  <address className={styles.address}>{address}</address>
                </li>
                <li className={styles.contact}>
                  <Phone className={styles.contactIcon} />
                  <a href={`tel:${phoneNo}`}>{phoneNo}</a>
                </li>
                <li className={styles.contact}>
                  <Mail className={styles.contactIcon} />
                  <a href={`mailto:${email}`}>{email}</a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        <div className={styles.copyright}>
          <div className={styles.copyrightContainer}>
            &copy; {new Date().getFullYear()} {siteName} All rights reserved
          </div>
        </div>

      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js